import { smartTransactionPlaceHolderData } from '~/utils/placeholderData'

export default (payload) => {
    const { transactionId, preventFatalError } = payload

    return useFetchWithTanstackQuery({
        queryKey: ['smartTransaction', transactionId.value],
        queryFn: () => $fetch(`/api/payment/transactions/${transactionId.value}`,),
        storageType: null,
        preventFatalError,
        options: {
            placeholderData: smartTransactionPlaceHolderData,
            staleTime: 0,
            cacheTime: 0
        }
    })
}
